<template>
  <div  class="main-container">
    <Particles
                id="tsparticles"
                :options="{
                  fpsLimit: 120,
                  particles: {
                    color: {
                      value: '#ccc'
                    },
                    move: {
                      enable: true
                    },
                    links: {
                      enable: true,
                      color: '#ccc'
                    }
                  }
                }"
        />   
    <img :src="require('../assets/dashboard-bg.jpg')" class="bg">
     <div id="loading" v-if="showLoading">
      <div class="content">
 
        <v-icon name="spinner" pulse scale="3" />

      </div>
    </div>

    <div class="header"> 
      <div class="d-flex" style="width:50%; cursor: pointer;" @click="goToDefault"> 
        <div class="mr-3"><v-icon name="chevron-left" class="chevron-left" /></div>
        <h5>{{ $t('blxDashboard.back') }}</h5>
      </div>
      <div>
        <a href="#" class="logout" v-on:click="logout">{{ $t('dashboard.logout') }}</a>
      </div>
    </div>

    <div class="btn-wrapper mt-3" style="width:100%">
      <div class="d-flex flex-wrap mt-3 justify-content-center" style="width:100%">
        <button class="btn cancel" :class="{ active: state.mainState == 'main'}" style="width:30%" @click="changeState('main', 'sub')">{{ $t('dashboard.mainWallet') }}</button>
        <button class="btn cancel" :class="{ active: state.mainState == 'stake'}" style="width:30%" @click="changeState('stake', 'sub')">{{ $t('history.stake') }}</button>
        <button class="btn cancel" :class="{ active: state.mainState == 'sub'}" style="width:30%" @click="changeState('sub', 'sub')">{{ $t('dashboard.subWallet') }}</button>
      </div>
    </div>

    <div class="transaction-content"> 
          
          <div class="history-content" v-if="state.mainState == 'main'">
            <div class="history-header" style="padding:5px;"> 
              <span> {{ $t('history.history') }} </span>
            </div>
            <table>
              <tr>
                <th>{{ $t('dashboard.timestamp') }}</th>
                <th>{{ $t('dashboard.hash') }}</th>
                <th>{{ $t('dashboard.input') }}</th>
                <th>{{ $t('dashboard.output') }}</th>
                <th>{{ $t('dashboard.amount') }}</th> 
                <th>{{ $t('dashboard.symbol') }}</th> 
                <th>{{ $t('dashboard.confirmations') }}</th> 
                <th>{{ $t('dashboard.status') }}</th>
              </tr>
              <tr v-for="h in mergedList" :key="h.hash" @click="initView(h, 'blx')">
                <td >{{ formatDate(h.input.timeStamp) }}</td>
                <td class="th-orange"> <div class="hash">{{ h.hash }}</div> </td>
                <td class="th-orange"> {{ h.senderWallet != null ? h.senderWallet.publicKey : "Newly generated BLX" }}  </td>
                <td class="th-orange">{{ h.recipient }}</td>
                <td> {{ formatAmount(h.amount) }} </td> 
                <td v-if="h.symbol != 'blx'"> {{ h.symbol }} </td> 
                <td v-if="h.symbol == 'blx'"> BLX </td> 
                <td> {{ h.confirmations }} </td> 
                <td v-if="h.confirmations >= 2">{{ $t('dashboard.completed') }}</td>
                <td v-else>{{ $t('dashboard.pending') }}</td>
              </tr>
              <!-- <tr v-for="h in daoHistory" :key="h.hash" @click="initView(h)" v-if="showDao">
                <td >{{ formatDate(h.input.timeStamp) }}</td>
                <td class="th-orange"> <div class="hash"><a :href="'https://explorer.blx.org/#/transaction/' + h.hash" target="_blank">{{ h.hash }}</a> </div> </td>
                <td class="th-orange"> {{ h.senderWallet != null ? h.senderWallet.publicKey : "Newly generated BLX" }}  </td>
                <td class="th-orange">{{ h.recipient }}</td>
                <td> {{ formatAmount(h.amount) }} </td> 
                <td> {{ h.symbol }} </td> 
                <td> {{ h.confirmations }} </td> 
                <td v-if="h.confirmations >= 2">COMPLETED</td>
                <td v-else>PENDING</td>
              </tr> -->
              <!-- <tr v-for="h in mintedHistory" :key="h.hash" @click="initView(h)">
                <td >{{ formatDate(h.input.timeStamp) }}</td>
                <td class="th-orange"> <div class="hash"><a :href="'https://explorer.blx.org/#/transaction/' + h.hash" target="_blank">{{ h.hash }}</a> </div> </td>
                <td class="th-orange"> {{ h.senderWallet != null ? h.senderWallet.publicKey : "Newly generated BLX" }}  </td>
                <td class="th-orange">{{ h.recipient }}</td>
                <td> {{ formatAmount(h.amount) }} </td> 
                <td> {{ h.symbol }} </td> 
                <td> {{ h.confirmations }} </td> 
                <td v-if="h.confirmations >= 2">COMPLETED</td>
                <td v-else>PENDING</td>
              </tr> -->
              
            
            </table>
            </div>
            <div class="history-content"  v-if="state.mainState == 'stake'">

            <div class="history-header" style="padding:5px;"> 
              <span> {{ $t('history.stakeHistory') }} </span>
              <div class="d-flex">
                <date-picker v-model="date.from" token="MM/DD/YY" valueType="MM/DD/YYYY"></date-picker>
                <date-picker v-model="date.to" token="MM/DD/YY" valueType="MM/DD/YYYY"></date-picker>
                <button class="btn btn-send" @click="getStakeHistory" style="background-color:#ccc; margin-top:0px;">{{ $t('history.go') }}</button>
              </div>
            </div>

            <table>
              <tr>
                <th>{{ $t('dashboard.timestamp') }}</th>
                <th>{{ $t('history.refId') }} </th>
                <th>{{ $t('history.bloxStake') }} </th> 
                <th>{{ $t('history.btcAmount') }} </th>  
                <th>{{ $t('dashboard.status') }}</th>
              </tr>
             
              <tr v-for="h in stakeHistory" :key="h.hash" @click="initView(h, 'stake')" v-if="showDao">
                <td >{{ formatDate(h.createDate) }}</td>
                <td class="th-orange">{{ h.stakingId }} </td>
                <td> {{ h.targetAmount }} </td> 
                <td> {{ h.sourceAmount.toFixed(8) }} </td>
                <td v-if="h.confirmations >= 2">{{ $t('dashboard.completed') }}</td>
                <td v-else>{{ $t('dashboard.pending') }}</td>
              </tr>
      
            </table>
        
          </div> 
          <div v-if="state.mainState == 'sub'">
        <div class="d-flex justify-content-between">
          <div></div>
          <b-dropdown id="dropdown-1" :text="$t('history.chooseAsset')" class="m-md-2">
            <div v-for="info in subwalletInfo" :key="info.id">
              <b-dropdown-item v-if="info.symbol != 'BLX' && info.symbol != 'BLOXDAO'" @click="getSubFund(info.symbol)">{{ info.symbol }}</b-dropdown-item>
            </div>
          </b-dropdown>
        </div>
        <div class="history-header"> 
          <span> {{ $t('history.history') }}  </span>
        </div>
        
        <div class="history-content">
          <table>
            <tr>
              <th>{{ $t('dashboard.timestamp') }}</th>
                <th>{{ $t('dashboard.hash') }}</th>
                <th>{{ $t('dashboard.input') }}</th>
                <th>{{ $t('dashboard.output') }}</th>
                <th>{{ $t('dashboard.amount') }}</th> 
                <th>{{ $t('dashboard.symbol') }}</th> 
                <th>{{ $t('dashboard.confirmations') }}</th> 
                <th>{{ $t('dashboard.status') }}</th>
            </tr>
            <tr v-for="h in selectedHistory" :key="h.hash" @click="initView(h)">
              <td >{{ formatDate(h.input.timeStamp) }}</td>
              <!-- <td class="th-orange"> <div class="hash"> <a :href="'https://explorer.blx.org/#/transaction/' + h.hash" target="_blank">{{ h.hash }}</a> </div> </td> -->
              <td class="th-orange"> <div class="hash"> <a :href="'https://explorer.blx.org/#/transaction/' + h.hash" target="_blank">{{ h.hash }}</a> </div> </td>
              <td class="th-orange"> {{ h.senderWallet != null ? h.senderWallet.publicKey : "BLX Genesis Asset" }}  </td>
              <td class="th-orange">{{ h.recipient }}</td>
              <td> {{ h.symbol }} {{ formatAmount(h.amount) }} </td> 
               <td class="th-orange">{{ h.confirmations }}</td>
               <td v-if="h.confirmations >= 2">{{ $t('dashboard.completed') }}</td>
                <td v-else>{{ $t('dashboard.pending') }}</td>
            </tr>
          
          </table>
      
  </div>
      </div>
    </div>
    <ViewHistory :historyInfo="historyInfo" :showBlxDao="showBlxDao" :showStake="showStake"/>
    <ConfirmLogout/>
  </div>
</template>

<script>

  import qs from 'querystring'
  import numeral from 'numeral' 
  import ViewHistory from '@/components/modal/ViewHistory.vue' 
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import ConfirmLogout from '@/components/modal/ConfirmLogout.vue'

  export default {
    name: 'history',
    components: {
      ViewHistory,
      DatePicker,
      ConfirmLogout
    },
    data: function() {
      return  {
        showLoading: true, 
        status: "",
        historyInfo:{},
        history: {},
        mintedHistory:{},
        stakeHistory: {},
        daoHistory:{},
        mergedList: {},
        showBlx: true,
        showDao: true,
        historyType: "",
        subwalletInfo: [],
        selectedHistory: [],
        selectedBalance: 0,
        date: {
          from: "03/14/2022",
          to: "",
        },

        state: {
          mainState: 'main',
        },
        showBlxDao: true,
        showStake: false,
      }
    },
    computed: {
      init() {
          return this.$store.state.init;
      },
    },
    methods: {
      changeState(name, type) {
          this.state.mainState = name
      },
      goToDefault() {
        this.$router.go(-1)
      },

      initView(content, type) {
        if(type == 'blx') {
          this.historyInfo = content
          this.showBlxDao = true
          this.showStake = false
          console.log(this.historyInfo)
          this.$bvModal.show('view-history-modal'); 
        } else if (type == 'stake') {
          this.historyInfo = content
          this.showBlxDao = false
          this.showStake = true
          console.log(this.historyInfo)
          this.$bvModal.show('view-history-modal'); 
        }
      },

      getSubwalletInfo() {
          const options = {
                method: 'GET',
                url: '/pub/wallets/' + this.init.address.addressValue,
                };
                this.axios(options)
                    .then((response) => {
                      console.log(response.data)
                          console.log('yes')
                          this.subwalletInfo = response.data
                          console.log(this.subwalletInfo)
                    })
                    .catch((error) => {
                      console.log(error)
                      // if(response.assetKey != "" && response.assetName == "") {
                      //   this.showSteps.one = false
                      //   this.showCheck.one = true
                      //   this.showSteps.two = false
                      //   this.showSteps.three = true
                      //   this.showCheck.two = true
                      //   this.isDisabled.three = false
                      // }
                    });
          },

      getSubFund: function(symbol){
         const options = {
            method: 'GET',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            url: '/blx-api/address/' + symbol + '/' + this.init.address.addressValue,
          };

          this.axios(options)
            .then((response) => {
               this.selectedBalance = response.data.balance
               this.selectedHistory = response.data.history;

              // console.log(this.init.fund.balance);

              this.selectedHistory.sort(function(a, b) {

                return parseFloat(b.input.timeStamp) - parseFloat(a.input.timeStamp);
              });

              console.log(this.selectedHistory)

              //this.init.fund.history = this.init.fund.history.slice(0, 10);

              }).catch((err) => {
                  
                console.log(err.response.data)     

                
              })
      },

      formatDate: function(time){
        return new Date(time).toLocaleString();
      },
      formatAmount: function(num){

        return numeral(num).format('0,0.00000000');
      },
      getAddress: function(){
         const options = {
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            url: '/cx/address/BLX',
          };

          this.axios(options)
            .then((response) => {
                this.init.address = response.data;
                //console.log(this.init.address)
                this.getFund();
                this.getSubwalletInfo();
              }).catch((err) => {
                  
                console.log(err.response.data)     

                
              })
      },

      getFund: function(){
         const options = {
            method: 'GET',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            url: '/blx-api/address/paginated/BLX/' + this.init.address.addressValue + '?page=1&itemsPerPage=15',
          };

          this.axios(options)
            .then((response) => {
               
               this.history = response.data.history;
               this.getDaoHistory();
               this.init.fund.history.forEach((value, index) => {
                  if(value.confirmations >= 1) {
                    console.log(value.confirmations)
                    this.status = "CONFIRMED"
                  } else {
                    console.log('error')
                    this.status = "UNCONFIRMED"
                  }

               });

              // console.log(this.init.fund.balance);

              this.init.fund.history.sort(function(a, b) {

                return parseFloat(b.input.timeStamp) - parseFloat(a.input.timeStamp);
              });

              //this.init.fund.history = this.init.fund.history.slice(0, 10);

              }).catch((err) => {
                  
                console.log(err.response.data)     

                
              })
      },

      getAssetInfo() {
          const options = {
                method: 'POST',
                url: '/cx/smartcontract',
                };
                this.axios(options)
                    .then((response) => {
                      this.getMintedFund(response.data.symbol, response.data.masterWalletAddress)
                    })
                    .catch((error) => {
                      // if(response.assetKey != "" && response.assetName == "") {
                      //   this.showSteps.one = false
                      //   this.showCheck.one = true
                      //   this.showSteps.two = false
                      //   this.showSteps.three = true
                      //   this.showCheck.two = true
                      //   this.isDisabled.three = false
                      // }
                    });
          },

      getMintedFund: function(symbol,address){
         const options = {
            method: 'GET',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            url: '/blx-api/address/'+ symbol +'/' + address,
          };

          this.axios(options)
            .then((response) => {
              
               this.mintedHistory = response.data.history;

              console.log(this.init.fund);
              // console.log(this.init.fund.balance);

              this.init.fund.history.sort(function(a, b) {

                return parseFloat(b.input.timeStamp) - parseFloat(a.input.timeStamp);
            });


              }).catch((err) => {
                  
                console.log(err.response.data)     

                
              })
      },

      getDaoHistory: function(){
         const options = {
            method: 'GET',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            url: '/blx-api/address/paginated/bloxdao/' + this.init.address.addressValue + '?page=1&itemsPerPage=15',
          };

          this.axios(options)
            .then((response) => {
              
               this.daoHistory = response.data.history;
               this.daoHistory.forEach((value, index) => {
                  value.symbol = "BLOX"
               });
              console.log(this.init.fund);
              this.sortByDate();
              // console.log(this.init.fund.balance);

              this.init.fund.history.sort(function(a, b) {

                return parseFloat(b.input.timeStamp) - parseFloat(a.input.timeStamp);
            });


              }).catch((err) => {
                  
                console.log(err.response.data)     

                
              })
      },

      getStakeHistory: function() {
        const params = {
          fromDate: this.date.from,
          toDate: this.date.to, 
        }

        const data = Object.keys(params)
          .map((key) => `${key}=${encodeURIComponent(params[key])}`)
          .join('&');
  

        const options = {
          method: 'POST',
          headers: { 'content-type': 'application/x-www-form-urlencoded' },
          data,
          url: '/cx/stake/history',
        };

        this.axios(options)
          .then((response) => { 
            console.log(response)
            this.stakeHistory = response.data.rowsList
            }).catch((err) => {
                
            })

    },

      sortHistory() {
        this.historyType = localStorage.getItem("history-type")
        console.log(this.historyType)
        if(this.historyType == "ALL" ) {
          this.showBlx = true
          this.showDao = true
        } else if(this.historyType == "BLX" ) {
          this.showBlx = true
          this.showDao = false
        } else if(this.historyType == "DAO" ) {
          this.showBlx = false
          this.showDao = true
          console.log('DAO')
        }  else {
          this.showBlx = true
          this.showDao = true
        }
      },

      sortByDate: function() {
        console.log(this.history)
        console.log(this.daoHistory)
        if(this.showBlx == true && this.showBlxDao == true) {
          this.mergedList = this.history.concat(this.daoHistory)
          return this.mergedList.sort(function(a, b) {
            return parseFloat(b.input.timeStamp) - parseFloat(a.input.timeStamp);
          });
        } else if(this.showBlx == true && this.showBlxDao == false) {
          this.mergedList = this.history
        } else if(this.showBlx == false && this.showBlxDao == true) {
          this.mergedList = this.daoHistory
        }
        console.log(this.mergedList)
        console.log('//')
      },


      getProfile: function(){
         const options = {
            method: 'GET',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            url: '/cx/profile/',
          };

          this.axios(options)
            .then((response) => {
               
               this.init.profile = response.data;

              console.log(this.init.profile);


                
              })
      },
      checkSession: function() {

        const options = {
          method: 'POST',
          headers: { 'content-type': 'application/x-www-form-urlencoded' },
          url: '/cx/sessioncheck',
        };

        this.axios(options)
          .then((response) => { 
            this.getProfile();
              setTimeout( () => {
                this.showLoading = false;
              },1000)
            }).catch((err) => {
                
              if(err.response.data.msgCode == '00001') {
                window.location.href = "/#/login";
              }  

              if(err.response.data.msgCode == '00020') {

                setTimeout( () => {
                window.location.href = "/#/setup-profile";
               },1000)
                
              }  

            })
      },

      currentDate() {
        const current = new Date();
        const nextDate = `${current.getMonth()+1}/${current.getDate()+1}/${current.getFullYear()}`;
        this.date.to = nextDate
        console.log(this.date.to)
      },

      logout: function(){
        this.$bvModal.show('logout-modal'); 
      }
    },

    beforeMount(){
      this.currentDate();
     this.checkSession();
      this.getAddress();
      this.getAssetInfo();
      this.getStakeHistory();
      this.sortHistory();
    },

    watch: {

    }
  }
</script>

<style scoped lang="scss">
  #loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000; 
  color: #FFF;
  display: -webkit-box;
  /* OLD - iOS 6-, Safari 3.1-6 */
  display: -moz-box;
  /* OLD - Firefox 19- (buggy but mostly works) */
  display: -ms-flexbox;
  /* TWEENER - IE 10 */
  display: -webkit-flex;
  /* NEW - Chrome */
  display: flex;
  /* NEW, Spec - Opera 12.1, Firefox 20+ */
  -webkit-justify-content: center;
  -moz-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  -moz-align-items: center;
  align-items: center;
      background: #141414;
}
#loading .content {
  display: inline-block;
  text-align: center;
}
#loading .content img {
  display: block;
  margin-bottom: 0.5em;
}
#loading .content .icon {
  font-size: 3em;
}

.main-container {
  /* background-color:#fff;
  height:100vh; */
}

.fa-icon { 
    color: #FFF;
    fill: #fff;
}
  .z-index-2 {
    z-index: 2;
    word-break: break-all
  }
  .transaction-content {
    padding: 0 14em;
    margin-top: 3em;

  }
  table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
    color: #333;
  }
   .hash {
    white-space: nowrap !important;
    width: 20em;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  td, th {
   
    text-align: left;
    padding: 1em;
    font-size: 0.75em;
  }

  td {  
    background: #ccc;
    color: #000;
    border-bottom: 1px solid #FFF;
    padding: 1.5em;
  
  }

  th {
     
    background: #000;
    color: #fff;
  }

  th:first-child { 
    border-top-left-radius: 6px;
  }
  th:last-child { 
    border-top-right-radius: 6px;
  }

  .history-content {

      border-radius: 6px;
        overflow-x:auto;
  }
    


  .history-container {  
      padding: 1.5em;
      border-radius: 6px;
      flex-direction: column;
      position: relative;
      background: #FFF;
      padding-top: 5em;
      color: #000;
      background-color: #de8413;
      background-image: linear-gradient(#de8413, #d8962c);
      width: 100%;
      margin: 0 2em;
  }
  
  .history-header {  
    color: #000;
    display: flex;
    justify-content: space-between;
    align-items: center;;

    a {
      color: #FFF;
      text-decoration: underline;
    }
  }
.logo {
    display:flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 2em;
    margin-top: 2em;
    img{
      width: 75px;  
    }
    
  }

  .cancel {
	  color:black;
	  background:none;
	  border-color:black;
	  border-width:1px;
	  font-family:'PoppinsMedium', sans-serif;
	  width:15%;
  }

  .cancel:hover {
    background-color:rgba(0, 0, 0, 0.15);
  }

  .active {
	  color:white;
	  background:black;
	  border-color:black;
	  border-width:1px;
	  font-family:'PoppinsMedium', sans-serif;
	  width:15%;
  }


  .option-box {

    background: #141414;
    border: 1px solid #8c5b13;
    color: #FFF;
    border-radius: 6px; 
    min-height: 15em;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 3em;
    cursor: pointer;

    h6 {
      font-size: 0.75em;
    }
  }
 .content-icon {
      width: 75px;
    }
  .balance {
    font-size: 0.8em;
    position: relative;
    width: 30%; 
    background-image: url(../assets/wallet-bg.png);
    box-shadow: -39px -40px 0px 0px rgba(222,132,19,0.75);
-webkit-box-shadow: -39px -40px 0px 0px rgba(222,132,19,0.75);
-moz-box-shadow: -39px -40px 0px 0px rgba(222,132,19,0.75);
    padding: 1em;
    color: #FFF;
    border-radius: 6px;
    min-height: 11em;
    display: flex;
    flex-direction: column;
    justify-content: center;
        background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    .bal-bg {
          position: absolute;
        z-index: 1;
        width: 20em;
        left: 2em;
        top: 2em;
    }
  }

  .header { 
    
    background: #141414;
    padding: 2em;
    display: flex;
    align-items: end;
    justify-content: space-between;
    color: #FFF;
  }
  .logout {
    color: #FFF;
  }

  .content {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 1em;
    padding: 0 15em;
  }

  .btn-secondary {
      background:none !important;
      border-color:orange !important;
      color:white !important;
      border-width:2px !important;
      margin-left:5px !important;
    }

  /*med*/
  @media(min-width: 40em) {
    
  }
  /*large*/
  @media(min-width: 64em) {

   
  }
  /*xl*/
  @media(min-width: 87.5em) {
    
  }


  /*sm*/
  @media(max-width: 39.9375em) {
 
  }
  /*med*/
  @media(max-width: 63.9375em) {

    
    
  }

  /*large*/
  @media(max-width: 87.4375em) {
    
  }

  @media(min-width: 768px) {
    .content {
      padding: 0 3em;
    }

    .transaction-content {
      padding: 3em;
    }

  }

</style>



